import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { MapPin, Mail, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const Contact = () => {
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com",
      icon: Facebook
    },
    {
      name: "Twitter",
      url: "https://www.twitter.com", 
      icon: Twitter
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com",
      icon: Instagram
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com",
      icon: Linkedin
    }
  ];

  const contactInfo = [
    {
      title: "Our Location",
      content: "Addis Ababa, Ethiopia",
      icon: MapPin
    },
    {
      title: "Email Us",
      content: "banteyrga@gmail.com",
      href: "mailto:banteyrga@gmail.com",
      icon: Mail
    },
    {
      title: "Email Us",
      content: "hello@palnet.et",
      href: "mailto:hello@palnet.et",
      icon: Mail
    }
  ];

  const ContactIcon = ({ icon: Icon }) => (
    <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 text-emerald-600 rounded-lg flex items-center justify-center">
      <Icon className="h-6 w-6" />
    </div>
  );

  const SocialIcon = ({ icon: Icon, name, url }) => (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={name}
      className="w-10 h-10 bg-gray-100 text-gray-600 hover:bg-emerald-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-300"
    >
      <Icon className="h-5 w-5" />
    </a>
  );

  return (
    <div className="bg-gradient-to-b from-white to-gray-50">
      <section className="relative">
        <div className="h-[50vh] relative overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url('./assets/images/others/coffee.jpg')`,
              transform: "translateZ(0)"
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-emerald-900/60" />
          <Header />
          <div className="absolute inset-0 flex items-center justify-center px-6">
            <div className="max-w-3xl text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight drop- animate-fadeIn">
                Contact Us
              </h1>
              <div className="w-24 h-1 bg-emerald-500 mx-auto mb-8" />
              <p className="text-xl text-white font-light max-w-2xl mx-auto">
                We're here to answer your questions and help you grow
              </p>
            </div>
          </div>
          
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" />
            </svg>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div className="bg-white p-8 rounded-2xl border border-gray-100">
                <h2 className="text-3xl font-bold text-gray-900 mb-6 relative text-left">
                  <span className="relative z-10">
                    Get In Touch
                    <span className="absolute -bottom-2 left-0 w-20 h-1 bg-emerald-500" />
                  </span>
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                  Have questions or want to learn more about our products? Reach out to us anytime!
                </p>
                <div className="space-y-6 text-left">
                  {contactInfo.map((info, index) => (
                    <div key={index} className="flex items-start space-x-4">
                      <ContactIcon icon={info.icon} />
                      <div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{info.title}</h3>
                        {info.href ? (
                          <a
                            href={info.href}
                            className="text-emerald-600 hover:text-emerald-800 transition-colors duration-300"
                          >
                            {info.content}
                          </a>
                        ) : (
                          <p className="text-gray-600 leading-relaxed">{info.content}</p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-10">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4 text-left">Connect With Us</h3>
                  <div className="flex space-x-5">
                    {socialLinks.map((social, index) => (
                      <SocialIcon key={index} {...social} />
                    ))}
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-gray-100">
                <h2 className="text-3xl font-bold text-gray-900 mb-6 relative text-left">
                  <span className="relative z-10">
                    Find Us
                    <span className="absolute -bottom-2 left-0 w-20 h-1 bg-emerald-500" />
                  </span>
                </h2>
                <p className="text-gray-600 mb-8 text-left">
                  Visit our office in Addis Ababa, Ethiopia. We're conveniently located and easy to find.
                </p>

                <div className="rounded-xl overflow-hidden h-[400px]">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.5734394087704!2d38.788447550798885!3d8.995837657377576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b8502cd1d569d%3A0xb47bdc83fbc6537a!2sMedhanealem%20Cathedral!5e0!3m2!1sam!2set!4v1743848568853!5m2!1sam!2set"
                    title="Export company"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
